import type { Check } from "../../api/check";
import { getCheckActiveLabel, getFailedCheckColorLabel } from "../../utils/checkFormat";
import "../RequestTable/RequestTable.scss";

interface CheckTableProps {
  data: Check[];
  onRowClick: (id: string) => void;
}

export const CheckTable = ({ data, onRowClick }: CheckTableProps) => (
  <div className="request-table-wrapper">
    <div className="request-table-card">
      <table className="request-table request-table--checks">
        <thead>
          <tr>
            <th>Код</th>
            <th>Описание</th>
            <th>Ответственность</th>
            <th>Текст для успешного отображения</th>
            <th>Текст ошибки</th>
            <th>Рекомендация</th>
            <th>Цвет проверки в отчете</th>
            <th>Статус</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={8} className="request-table-empty">
                Нет данных
              </td>
            </tr>
          ) : (
            data.map((item) => (
              <tr
                key={item.id}
                className="request-table-row-clickable"
                onClick={() => item.id && onRowClick(item.id)}
              >
                <td>{item.code?.trim() || "—"}</td>
                <td>{item.description?.trim() || "—"}</td>
                <td>{item.responsibility?.trim() || "—"}</td>
                <td>{item.successText?.trim() || "—"}</td>
                <td>{item.failText?.trim() || "—"}</td>
                <td>{item.suggestion?.trim() || "—"}</td>
                <td>{getFailedCheckColorLabel(item.failedCheckColor)}</td>
                <td>
                  <span
                    className={`request-table-status${
                      item.active === false ? " request-table-status--inactive" : ""
                    }`}
                  >
                    {getCheckActiveLabel(item.active)}
                  </span>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </div>
);
